import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const readNotifstore = new Vuex.Store({
    namespaced: true,  // Add this line if needed
    state: {
        readCount: 0,
        cabangId: null,
        gadaiEmas: {
            input: {
                jenisEmas: null,
                merkEmas: null,
                tipeEmas: null,
                karatEmas: null,
                spesifikasiBarangJenis: [],
                kelengkapanBarang: [],
                beratKering: null,
                beratBasah: null,
                jumlah: 1,
                keterangan: "",
                promo: [],
                nilaiPinjaman: 0,
                warnaBatu: null,

                fotoPendukung: [
                    {
                        index: 0,
                        id: 0,
                        checkFotoBarangPendukung: false,
                        fotoBarangPendukungPlaceholder: 'Choose a file',
                        fotoBarangPendukung: null,
                        fotoBarangPendukungBase64: null,
                        activeFotoPendukungBase64: null,
                    }
                ],

                batu: [],
                beratTambahan: null,
                potonganTambahan: [],

                capEmas: null,
                kemasanEmas: null
            },
        }

    }
});